import {Component, OnInit, AfterViewInit, ViewChild, Input, Output, EventEmitter} from '@angular/core';
import {LocationStrategy} from '@angular/common';
import {MatTabGroup} from '@angular/material/tabs';

import {SistemaService} from '@servicios/Sistema.Service';
import {AlertaEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';

import {ColaboradorGeneralComponent} from './seccion/colaborador_general.component';

@Component({
    selector: 'colaboradorForm',
    templateUrl: './colaboradorForm.component.html',
    styleUrls: ['./colaborador.component.scss']
})
export class ColaboradorFormComponent implements OnInit, AfterViewInit {
    @ViewChild('tab') private tab!: MatTabGroup;
    @ViewChild('general') private generalComponent!: ColaboradorGeneralComponent;

    @Input() accion!: {accionid: number, accion: string};
    @Input() id!: number;
    @Output() output = new EventEmitter();

    cambio: boolean = false;

    constructor(private location: LocationStrategy, public sistemaService: SistemaService, private mensajeService: MensajeService) {
        history.pushState(null, "", window.location.href);
        this.location.onPopState(() => {
            this.Salir();
        });
    }

    ngOnInit() {
        //this._helper.PaginaUp();
    }

    ngAfterViewInit() {
        // 1. Save the click handler for later
        const handleTabClick = this.tab._handleClick;

        // 2. Replace the click handler with our custom function
        this.tab._handleClick = (tab, header, index) => {
            switch (this.tab.selectedIndex) {
                case 0:
                    if (this.accion.accionid == 2 && this.id) {
                        handleTabClick.apply(this.tab, [tab, header, index]);
                    } else {
                        let respuesta = this.generalComponent.Validar();
                        if (respuesta === true) {
                            this.generalComponent.Guardar().then(res => {
                                this.id = res.id;
                                if (res.cambio) {
                                    this.cambio = true;
                                }
                            });
                            handleTabClick.apply(this.tab, [tab, header, index]);
                        } else {
                            this.mensajeService.Alerta(AlertaEnum.Warning, respuesta);
                        }
                    }
                    break;
                case 1:
                case 2:
                case 3:
                    handleTabClick.apply(this.tab, [tab, header, index]);
                    break;
            }
        };
    }

    Salir() {
        this.output.next(this.cambio);
    }

    Guardar() {
        switch (this.tab.selectedIndex) {
            case 0:
                this.generalComponent.Guardar().then(res => {
                    this.id = res.id;
                    if (res.cambio) {
                        this.cambio = true;
                    }
                    this.tab.selectedIndex = 1;
                });
                break;
            case 1:
                this.tab.selectedIndex = 2;
                break;
            case 2:
                this.tab.selectedIndex = 3;
                break;
            case 3:
                this.Salir();
                break;
        }
    }

    Atras() {
        switch (this.tab.selectedIndex) {
            case 1:
                this.tab.selectedIndex = 0;
                break;
            case 2:
                this.tab.selectedIndex = 1;
                break;
            case 3:
                this.tab.selectedIndex = 2;
                break;
        }
    }
}
